import { render, staticRenderFns } from "./BoxTemplate.vue?vue&type=template&id=600a45e0&scoped=true&"
import script from "./BoxTemplate.vue?vue&type=script&lang=js&"
export * from "./BoxTemplate.vue?vue&type=script&lang=js&"
import style0 from "./BoxTemplate.vue?vue&type=style&index=0&id=600a45e0&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600a45e0",
  null
  
)

export default component.exports